import { render, staticRenderFns } from "./SettingsComponent.vue?vue&type=template&id=49fe2d61&"
import script from "./SettingsComponent.vue?vue&type=script&lang=ts&"
export * from "./SettingsComponent.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports